export const LOAD_CUSTOMER_STATUS = 'LOAD_CUSTOMER_STATUS'
export const ADD_CUSTOMER_STAT = 'ADD_CUSTOMER_STAT'
export const UPDATE_CUSTOMER_STAT = 'UPDATE_CUSTOMER_STAT'
export const DELETE_CUSTOMER_STAT = 'DELETE_CUSTOMER_STAT'
